import React from 'react'
import { useSelector } from 'react-redux'
import { ThemeVariants, Typography, TypographyTypes } from 'rds'
import api from '../../api'

const CheckoutFormDiscountCodeBadge = ({ className, discount, onRemove }) => {
    const cartEntries = useSelector(state => state.cart.entries)
    const [productsThatApply, setProductsThatApply] = React.useState([])

    const getProductsThatApply = React.useCallback(async () => {
        if (discount.type !== 'PRODUCTS_DISCOUNT' || discount.isCatchAll) {
            setProductsThatApply([])
            return
        }

        // Get full products data
        const url = new URL('products', api.defaults.baseURL)
        cartEntries.forEach(entry => {
            url.searchParams.append('_id[]', entry.item._id || entry.item)
        })
        const res = await api.get(decodeURIComponent(url))
        const cartProducts = res.data.products

        // Get products that apply to discount
        const productsThatApply = []
        discount.tags.forEach(tagId => {
            cartProducts.forEach(product => {
                if (product.tags.find(tag => tag._id === tagId)) {
                    productsThatApply.push(product)
                }
            })
        })
        setProductsThatApply(productsThatApply)
    }, [discount.type, discount.isCatchAll, discount.tags, cartEntries])

    React.useEffect(() => {
        getProductsThatApply()
    }, [getProductsThatApply])

    return (
        <div className={className}>
            <div className='rds-flex rds-align-center'>
                <div className='rds-flex rds-align-center'>
                    <Typography
                        type={TypographyTypes.H4}
                        className='rds-m_right__sm'
                    >
                        {discount.name}
                    </Typography>
                    {discount.isCatchAll ? (
                        <Typography
                            className='rds-overflow_hidden rds-nowrap'
                            style={{ textOverflow: 'ellipsis', opacity: 0.5 }}
                        >
                            Aplica a todos los productos
                        </Typography>
                    ) : null}
                    {productsThatApply.length ? (
                        <Typography
                            className='rds-overflow_hidden rds-nowrap'
                            style={{ textOverflow: 'ellipsis', opacity: 0.5 }}
                        >
                            Aplica a{' '}
                            {productsThatApply
                                .map(
                                    productThatApplies =>
                                        productThatApplies.name,
                                )
                                .join(', ')}
                        </Typography>
                    ) : null}
                </div>
            </div>
            <div className='rds-flex rds-align-center'>
                {discount.method !== 'AUTOMATIC' ? (
                    <div
                        onClick={() => onRemove(discount.id)}
                        style={{ cursor: 'pointer' }}
                    >
                        <Typography
                            className='rds-text-variant_link'
                            variant={ThemeVariants.MAIN}
                        >
                            Remover
                        </Typography>
                    </div>
                ) : null}
                <Typography
                    className='rds-text-align_right'
                    style={{ minWidth: 60 }}
                >
                    {discount.value
                        ? `- ${discount.mode === 'PERCENTAGE' ? '' : '$'}${discount.value}${discount.mode === 'PERCENTAGE' ? '%' : ''}`
                        : ''}
                </Typography>
            </div>
        </div>
    )
}

export default CheckoutFormDiscountCodeBadge
